import { render } from "./EditForm.vue?vue&type=template&id=2c57fce2&scoped=true"
import script from "./EditForm.vue?vue&type=script&lang=js"
export * from "./EditForm.vue?vue&type=script&lang=js"

import "./EditForm.vue?vue&type=style&index=0&id=2c57fce2&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c57fce2"],['__file',"src/components/EditForm/EditForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2c57fce2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2c57fce2', __exports__)) {
    api.reload('2c57fce2', __exports__)
  }
  
  module.hot.accept("./EditForm.vue?vue&type=template&id=2c57fce2&scoped=true", () => {
    api.rerender('2c57fce2', render)
  })

}


export default __exports__